module.exports = __webpack_public_path__ + "static/media/transaction3.290165a1.png";